import { Check } from 'lucide-react'
import { cn } from '../../utils/cn'

// Bloco "COMO CONDUZIMOS UMA OPORTUNIDADE" (frame 585:8619): eyebrow + citação
// itálica / parágrafo em 2 colunas + stepper horizontal de N etapas — círculos
// numerados em outline e a última etapa preenchida com check — + fechamento
// centralizado em 2 linhas (2ª em destaque).
// steps: array de { title, description }
export default function OpportunityStepper({
  heading = '',
  quote = '',
  lead = '',
  steps = [],
  closing = { line1: '', line2: '' },
  accentClass = 'text-[#264F8D]',
  accentBorderClass = 'border-[#264F8D]',
  accentBgClass = 'bg-[#264F8D]',
}) {
  return (
    <div className="w-full px-20">
      {heading && (
        <h2 className="pt-10 pb-6 font-inter-extrabold text-2xl tracking-[-0.02em] text-[#454545]">
          {heading}
        </h2>
      )}

      {(quote || lead) && (
        <div className="flex flex-col gap-10 pb-8 md:flex-row md:justify-between md:gap-20">
          {quote && (
            <p className="font-inter-extralight text-[28px] italic leading-[1.08] tracking-[-0.02em] text-[#454545] md:max-w-[564px]">
              {quote}
            </p>
          )}
          {lead && (
            <p className="pt-2 font-inter-regular text-base leading-[1.08] text-[#454545] md:max-w-[548px]">
              {lead}
            </p>
          )}
        </div>
      )}

      {steps.length > 0 && (
        <div className="relative pb-8">
          {/* linha horizontal atrás dos círculos (só no desktop) */}
          <div className="absolute inset-x-4 top-[28px] hidden h-px bg-[#D9D9D9] md:block" />

          <ol className="relative flex flex-col gap-8 md:flex-row md:gap-0">
            {steps.map((step, index) => {
              const isLast = index === steps.length - 1

              return (
                <li
                  key={index}
                  className="flex items-start gap-5 md:flex-1 md:flex-col md:items-center md:gap-0 md:text-center"
                >
                  <span
                    className={cn(
                      'flex h-14 w-14 shrink-0 items-center justify-center rounded-full',
                      isLast
                        ? accentBgClass
                        : cn('border-2 bg-white', accentBorderClass),
                    )}
                  >
                    {isLast ? (
                      <Check size={22} className="text-white" />
                    ) : (
                      <span
                        className={cn(
                          'font-inter-extrabold text-sm leading-none',
                          accentClass,
                        )}
                      >
                        {String(index + 1).padStart(2, '0')}
                      </span>
                    )}
                  </span>

                  <span className="flex flex-col md:px-3 md:pt-5">
                    <span
                      className={cn(
                        'font-inter-extrabold text-base tracking-[-0.02em]',
                        accentClass,
                      )}
                    >
                      {step.title}
                    </span>
                    <span className="pt-2 font-inter-regular text-sm leading-[1.3] text-[#707070]">
                      {step.description}
                    </span>
                  </span>
                </li>
              )
            })}
          </ol>
        </div>
      )}

      {(closing.line1 || closing.line2) && (
        <p className="pb-12 text-center font-inter-regular text-base leading-[1.08] text-[#454545]">
          {closing.line1}
          {closing.line2 && (
            <>
              <br />
              <span className="font-inter-bold">{closing.line2}</span>
            </>
          )}
        </p>
      )}
    </div>
  )
}
